export default __webpack_public_path__ + "static/media/refresh_icon.d107f9a7.svg";